import { render, staticRenderFns } from "./filter-price-range.vue?vue&type=template&id=c009d6a8&scoped=true&"
import script from "./filter-price-range.vue?vue&type=script&lang=js&"
export * from "./filter-price-range.vue?vue&type=script&lang=js&"
import style0 from "./filter-price-range.vue?vue&type=style&index=0&id=c009d6a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c009d6a8",
  null
  
)

export default component.exports